<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="router-view1"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="router-view2"></router-view>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // console.log(this.$route)
  }
};
</script>

<style lange="less">
@import "../src/assets/style/main.theme.less";
@import "../src/assets/icon/iconfont.css";

*,
body {
  padding: 0;
  margin: 0;
  max-width: 750px;
  margin: 0 auto;
}
</style>
